/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function() {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetOpenInvInqsByExaminer: {
        $xmlns: 'http://dobs.pa.gov/sc/investigationinquiry/bpm/1.0'
      }
    },
    blueprintArrays: ['GetOpenInvInqsByExaminerResponse.InvInq'],
    blueprint: {
      invInqs: [
        '$..InvInq',
        {
          id: '$.ID',
          dbaName: '$.DBAName',
          applicantLegalName: '$.ApplicantLegalName',
          crdNumber: '$.CRDNumber',
          licenseType: '$.LicenseType',
          caseNumber: '$.CaseNumber',
          category: '$.Category',
          objectId: '$.ObjectID',
          objectTypeId: '$.ObjectTypeID'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      _.each(response.invInqs, function(invInq) {
        invInq.licenseType = invInq.licenseType || '--';
      });
      defer.resolve(response.invInqs);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
